import { gql } from "@apollo/client";

export const GET_RAG_DOCUMENT_UPLOADS = gql`
  query GetRagDocumentUploads($first: Int, $after: String, $school: ID) {
    ragDocumentUploads(first: $first, after: $after, school: $school) {
      edges {
        cursor
        node {
          id
          originalFilename
          fileSize
          fileType
          sourceType
          createdAt
          fileUrl
          suggestedTags
          approvedTags
          tagsApproved
          chunkCount
          chunksSyncedAt
          canHaveChildren
          allowedChildTypes
          job {
            id
            status
            progress
            logs {
              id
              message
              createdAt
            }
          }
          parent {
            id
            originalFilename
            sourceType
          }
          children {
            id
            originalFilename
            fileSize
            fileType
            sourceType
            createdAt
            fileUrl
            chunkCount
            canHaveChildren
            allowedChildTypes
            job {
              id
              status
            }
            children {
              id
              originalFilename
              fileSize
              fileType
              sourceType
              createdAt
              fileUrl
              chunkCount
              job {
                id
                status
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const GET_RAG_SOURCE_TYPES = gql`
  query GetRagSourceTypes {
    ragSourceTypes
  }
`;

export const GET_ELIGIBLE_PARENT_DOCUMENTS = gql`
  query GetEligibleParentDocuments($sourceType: String!) {
    eligibleParentDocuments(sourceType: $sourceType) {
      id
      originalFilename
      sourceType
      createdAt
      allowedChildTypes
    }
  }
`;
